import React from 'react';
import css from '../../../../styles/modules/PaymentSummary/details.module.css';
import moment from 'moment';

export default function Details({
  notes,
  propertyInfo,
  from,
  to,
  createdOn,
  purpose,
}) {
  const { street1, street2, zip, state, city } = propertyInfo;

  // below 3 lines of code avoid "undefined" in address if val is missing
  const firstGroup = [street1, street2, city].filter((part) => !!part);
  const secondGroup = [state, zip].filter((part) => !!part);
  const addressString = [...firstGroup, secondGroup?.join(' ')].join(', ');

  return (
    <div className={css.wrapper}>
      <div className={css.containerLeft}>
        <p className={css.subHeadlines}>Created On</p>
        <p className={css.textRegular}>
          {createdOn ? moment(createdOn).format('MM/DD/YY HH:MM a') : ' '}
        </p>
        <p className={css.subHeadlines}>From</p>
        <p className={css.textRegular}>
          {`${from?.firstName || ''} ${from?.lastName || ''}`.trim()}
        </p>
        <p className={css.subHeadlines}>Property</p>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            lineHeight: '17px',
            marginTop: '5px',
          }}
        >
          <p className={css.textRegular}>{addressString}</p>
        </div>
      </div>
      <div className={css.containerRight}>
        <p className={css.subHeadlines}>Purpose</p>
        <p className={css.textRegular}>{purpose}</p>
        <p className={css.subHeadlines}>To</p>
        <p className={css.textRegular}>{to?.name}</p>
        <p className={css.subHeadlines}>Notes</p>
        <p className={css.textRegular}>{notes}</p>
      </div>
    </div>
  );
}
